export const getYearOptions = (count = 5) => {
    const options = [];
    const currentYear = new Date().getFullYear();

    // Financial year starts from April
    const startYear = new Date().getMonth() >= 3 
        ? currentYear 
        : currentYear - 1;

    for (let i = count - 1; i >= 0; i--) {
        const fromYear = startYear - i;
        const toYear = fromYear + 1;

        options.push(`${fromYear}-${String(toYear).slice(-2)}`);
    }

    return options;
};




export const MISformP1 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Talukas covered",
        "response": [
            {
                "fieldName": "talukasCovered",
                "responseVal": "talukasCovered",
                "responseName": "Talukas covered",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Name of the main yard",
        "response": [
            {
                "fieldName": "mainYardName",
                "responseVal": "nameOfMainYard",
                "responseName": "Name of the main yard",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Subyard",
        "response": [
            {
                "fieldName": "subyardName",
                "responseVal": "subyardName",
                "responseName": "Subyard Name",
                "responseType": "input"
            },
            {
                "fieldName": "subyardAddress",
                "responseVal": "subyardAddress",
                "responseName": "Subyard Address",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Is the market committee located in a tribal area?",
        "response": [
            {
                "fieldName": "isTribalArea",
                "responseVal": "isTribalArea",
                "responseName": "Is the market committee located in a tribal area?",             
                "responseType": "select",
                "options": ["true", "false"]
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Chairman",
        "response": [
            {
                "fieldName": "chairmanName",
                "responseVal": "chairmanName",
                "responseName": "Chairman Name",
                "responseType": "input"
            },
            {
                "fieldName": "chairmanTenure",
                "responseVal": "chairmanTenure",
                "responseName": "Chairman Tenure",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "07.",
        "fieldVal": "Vice Chairman",
        "response": [
            {
                "fieldName": "viceChairmanName",
                "responseVal": "viceChairmanName",
                "responseName": "Vice Chairman Name",
                "responseType": "input"
            },
            {
                "fieldName": "viceChairmanTenure",
                "responseVal": "viceChairmanTenure",
                "responseName": "Vice Chairman Tenure",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "08.",
        "fieldVal": "Total number of villages/towns/cities in the market area of the market committee",
        "response": [
            {
                "fieldName": "totalSettlementsInArea",
                "responseVal": "totalVillagesTownsCities",
                "responseName": "Total number of villages/towns/cities",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "09.",
        "fieldVal": "Stocks",
        "response": [
            {
                "fieldName": "stocks",
                "responseVal": "stocks",
                "responseName": "Stocks",
                "responseType": "input"
            }
        ]
    }
]
 
export const MISformP2 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Income (in lakhs)",
        "response": [
            {
                "fieldName": "incomeMarketFees",
                "responseVal": "incomeMarketFees",
                "responseName": "Market fee",
                "responseType": "number"
            },
            {
                "fieldName": "incomeLicenseFees",
                "responseVal": "incomeLicenseFees",
                "responseName": "License fee",
                "responseType": "number"
            },
            {
                "fieldName": "incomeMiscellaneous",
                "responseVal": "incomeMiscellaneous",
                "responseName": "Miscellaneous income",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Total income",
        "response": [
            {
                "fieldName": "totalIncome",
                "responseVal": "totalIncome",
                "responseName": "Total income",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Number of licensed traders",
        "response": [
            {
                "fieldName": "noOfLicensedTraders",
                "responseVal": "noOfLicensedTraders",
                "responseName": "Number of licensed traders",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Number of licensed cooperative societies",
        "response": [
            {
                "fieldName": "noOfLicensedCooperativeSocieties",
                "responseVal": "noOfLicensedCooperativeSocieties",
                "responseName": "Number of licensed cooperative societies",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Cost (in lakhs)",
        "response": [
            {
                "fieldName": "costInstitutionalExpenses",
                "responseVal": "costInstitutionalExpenses",
                "responseName": "Institutional expenses",
                "responseType": "number"
            },
            {
                "fieldName": "costOtherExpenses",
                "responseVal": "costOtherExpenses",
                "responseName": "Other expenses",
                "responseType": "number"
            },
            {
                "fieldName": "costConstruction",
                "responseVal": "costConstruction",
                "responseName": "Construction cost",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "07.",
        "fieldVal": "Total cost minus construction cost. Enter the amount.",
        "response": [
            {
                "fieldName": "totalCostMinusConstructionCost",
                "responseVal": "totalCostMinusConstructionCost",
                "responseName": "Total cost minus construction cost",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "08.",
        "fieldVal": "What percentage of total expenditure is institutional expenditure?",
        "response": [
            {
                "fieldName": "institutionalExpenditurePercentage",
                "responseVal": "institutionalExpenditurePercentage",
                "responseName": "Percentage of institutional expenditure",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "09.",
        "fieldVal": "What percentage of the total cost is the construction cost?",
        "response": [
            {
                "fieldName": "constructionCostPercentage",
                "responseVal": "constructionCostPercentage",
                "responseName": "Percentage of construction cost",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "10.",
        "fieldVal": "Increase in income over expenditure",
        "response": [
            {
                "fieldName": "incomeOverExpenditure",
                "responseVal": "incomeOverExpenditure",
                "responseName": "Increase in income over expenditure",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "11.",
        "fieldVal": "Costs increase more than yields",
        "response": [
            {
                "fieldName": "costsIncreaseOverYields",
                "responseVal": "costsIncreaseOverYields",
                "responseName": "Costs increase more than yields",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "12.",
        "fieldVal": "Market Committee Category by Income (A B C D)",
        "response": [
            {
                "fieldName": "marketCommitteeCategoryByInc",
                "responseVal": "marketCommitteeCategoryByInc",
                "responseName": "Market Committee Category",
                "responseType": "select",
                "options": ["A", "B", "C", "D"]
            }
        ]
    }
]
 
export const MISformP3 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Total assistance received by market committees year-wise in lakhs",
        "response": [
            {
                "fieldName": "totalAssistanceYear",
                "responseVal": "totalAssistanceYear",
                "responseName": "Year",
                "responseType": "select",
                "options": getYearOptions(4)
            },
            {
                "fieldName": "totalAssistanceAmount",
                "responseVal": "totalAssistanceAmount",
                "responseName": "Amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Total loans received by market committees year-wise (in lakhs)",
        "response": [
            {
                "fieldName": "totalLoanYear",
                "responseVal": "totalLoanYear",
                "responseName": "Year",
                "responseType": "select",
                "options": getYearOptions(4)
            },
            {
                "fieldName": "totalLoanAmount",
                "responseVal": "totalLoanAmount",
                "responseName": "Amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Details of the loan repaid (in lakhs)",
        "response": [
            {
                "fieldName": "loanRepaidAmount",
                "responseVal": "loanRepaidAmount",
                "responseName": "Amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Interest (in lakhs)",
        "response": [
            {
                "fieldName": "interestAmount",
                "responseVal": "interestAmount",
                "responseName": "Amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Outstanding loan against each loan (in lakhs)",
        "response": [
            {
                "fieldName": "outstandingLoanAmount",
                "responseVal": "outstandingLoanAmount",
                "responseName": "Amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "07.",
        "fieldVal": "Permanent Fund of Market Committees as on 31/03/2025 (in lakhs)",
        "response": [
            {
                "fieldName": "permanentFundAmount",
                "responseVal": "permanentFundAmount",
                "responseName": "Amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "08.",
        "fieldVal": "Reasons for loan arrears",
        "response": [
            {
                "fieldName": "loanArrearsReasons",
                "responseVal": "loanArrearsReasons",
                "responseName": "Reasons for loan arrears",
                "responseType": "input"
            }
        ]
    }
]
 
export const MISformP4 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Quantity of agricultural produce produced in the market area",
        "response": [
            {
                "fieldName": "quantityAgriProduce",
                "responseVal": "quantityAgriProduce",
                "responseName": "Quantity",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "The cost of production of agricultural produce in the market area",
        "response": [
            {
                "fieldName": "costOfProduction",
                "responseVal": "costOfProduction",
                "responseName": "Cost of production",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Revenue from controlled substances in the market yard during the year",
        "response": [
            {
                "fieldName": "revenueControlledSubstances",
                "responseVal": "revenueControlledSubstances",
                "responseName": "Revenue",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Price of controlled commodities in the market yard during the year",
        "response": [
            {
                "fieldName": "priceControlledCommodities",
                "responseVal": "priceControlledCommodities",
                "responseName": "Price of controlled commodities",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Sales of controlled substances in the market yard during the year",
        "response": [
            {
                "fieldName": "salesControlledSubstances",
                "responseVal": "salesControlledSubstances",
                "responseName": "Sales",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "07.",
        "fieldVal": "Price of controlled goods sold in the market yard",
        "response": [
            {
                "fieldName": "priceControlledGoodsSold",
                "responseVal": "priceControlledGoodsSold",
                "responseName": "Price of goods sold",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "08.",
        "fieldVal": "Total",
        "response": [
            {
                "fieldName": "totalAmount",
                "responseVal": "totalAmount",
                "responseName": "Total",
                "responseType": "number"
            }
        ]
    }
];
 
export const MISformP5 = [
   
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Number of cooperatives holding market committee licenses",
        "response": [
            {
                "fieldName": "noOfCooperativesHoldingLicenses",
                "responseVal": "noOfCooperativesHoldingLicenses",
                "responseName": "Number of cooperatives holding market committee licenses",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Number of unlicensed cooperatives in the market area",
        "response": [
            {
                "fieldName": "noOfUnlicensedCooperatives",
                "responseVal": "noOfUnlicensedCooperatives",
                "responseName": "Number of unlicensed cooperatives in the market area",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Trade done by cooperatives (in lakhs)",
        "response": [
            {
                "fieldName": "tradeDoneByCooperatives",
                "responseVal": "tradeDoneByCooperatives",
                "responseName": "Trade done by cooperatives (in lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Trade done by traders (in lakhs)",
        "response": [
            {
                "fieldName": "tradeDoneByTraders",
                "responseVal": "tradeDoneByTraders",
                "responseName": "Trade done by traders (in lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Remarks",
        "response": [
            {
                "fieldName": "remarks",
                "responseVal": "remarks",
                "responseName": "Remarks",
                "responseType": "textarea"
            }
        ]
    }
];

export const MISformP6 = [
    
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "License type",
        "response": [
            {
                "fieldName": "licenseType",
                "responseVal": "licenseType",
                "responseName": "License type",
                "responseType": "select",
                "options": [
                    "Unified License",
                    "General Commission Agent License",
                    "Others (porters, tolats etc.)",
                    "Total"
                ]
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Number of licenses",
        "response": [
            {
                "fieldName": "numberOfLicenses",
                "responseVal": "numberOfLicenses",
                "responseName": "Number of licenses",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "License fee rate",
        "response": [
            {
                "fieldName": "licenseFeeRate",
                "responseVal": "licenseFeeRate",
                "responseName": "License fee rate",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Total amount deposited for license (in lakhs of rupees, paisa)",
        "response": [
            {
                "fieldName": "totalAmountDeposited",
                "responseVal": "totalAmountDeposited",
                "responseName": "Total amount deposited",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Remarks",
        "response": [
            {
                "fieldName": "remarks",
                "responseVal": "remarks",
                "responseName": "Remarks",
                "responseType": "textarea"
            }
        ]
    }
];

export const MISformP7 = [
    
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Year",
        "response": [
            {
                "fieldName": "year",
                "responseVal": "year",
                "responseName": "Year",
                "responseType": "select",
                "options": ["2022-23", "2023-24", "2024-25"]
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Income (in lakhs)",
        "response": [
            {
                "fieldName": "incomeInLakhs",
                "responseVal": "incomeInLakhs",
                "responseName": "Income (in lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Cost (in lakhs)",
        "response": [
            {
                "fieldName": "costInLakhs",
                "responseVal": "costInLakhs",
                "responseName": "Cost (in lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Savings/Loss (in lakhs)",
        "response": [
            {
                "fieldName": "savingsOrLoss",
                "responseVal": "savingsOrLoss",
                "responseName": "Savings/Loss (in lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Permanent Fund (in lakhs)",
        "response": [
            {
                "fieldName": "permanentFund",
                "responseVal": "permanentFund",
                "responseName": "Permanent Fund (in lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "07.",
        "fieldVal": "Remarks",
        "response": [
            {
                "fieldName": "remarks",
                "responseVal": "remarks",
                "responseName": "Remarks",
                "responseType": "textarea"
            }
        ]
    }
];

export const MISformP8 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },

    // -------------------- Grain Department --------------------
    {
        "fieldNo": "02.",
        "fieldVal": "Grain Department",
        "response": [
            {
                "fieldName": "grainBirthName",
                "responseVal": "grainBirthName",
                "responseName": "Birth name",
                "responseType": "input"
            },
            {
                "fieldName": "grainIncomeQuintals",
                "responseVal": "grainIncomeQuintals",
                "responseName": "Income (in quintals)",
                "responseType": "number"
            },
            {
                "fieldName": "grainPriceLakhs",
                "responseVal": "grainPriceLakhs",
                "responseName": "Price (in lakhs)",
                "responseType": "number"
            },
            {
                "fieldName": "grainAnnualAvgPriceQty",
                "responseVal": "grainAnnualAvgPriceQty",
                "responseName": "Annual average price (Qty.)",
                "responseType": "number"
            },
            {
                "fieldName": "grainSalesVolumeQuintals",
                "responseVal": "grainSalesVolumeQuintals",
                "responseName": "Sales volume (in quintals)",
                "responseType": "number"
            },
            {
                "fieldName": "grainSellingPriceLakhs",
                "responseVal": "grainSellingPriceLakhs",
                "responseName": "Selling price (in lakhs)",
                "responseType": "number"
            }
        ]
    },

    // -------------------- Vegetable Section --------------------
    {
        "fieldNo": "03.",
        "fieldVal": "Vegetable Section",
        "response": [
            {
                "fieldName": "vegetableBirthName",
                "responseVal": "vegetableBirthName",
                "responseName": "Birth name",
                "responseType": "input"
            },
            {
                "fieldName": "vegetableIncomeQuintals",
                "responseVal": "vegetableIncomeQuintals",
                "responseName": "Income (in quintals)",
                "responseType": "number"
            },
            {
                "fieldName": "vegetablePriceLakhs",
                "responseVal": "vegetablePriceLakhs",
                "responseName": "Price (in lakhs)",
                "responseType": "number"
            },
            {
                "fieldName": "vegetableAnnualAvgPriceQty",
                "responseVal": "vegetableAnnualAvgPriceQty",
                "responseName": "Annual average price (Qty.)",
                "responseType": "number"
            },
            {
                "fieldName": "vegetableSalesVolumeQuintals",
                "responseVal": "vegetableSalesVolumeQuintals",
                "responseName": "Sales volume (in quintals)",
                "responseType": "number"
            },
            {
                "fieldName": "vegetableSellingPriceLakhs",
                "responseVal": "vegetableSellingPriceLakhs",
                "responseName": "Selling price (in lakhs)",
                "responseType": "number"
            }
        ]
    },

    // -------------------- Fruit Department --------------------
    {
        "fieldNo": "04.",
        "fieldVal": "Fruit Department",
        "response": [
            {
                "fieldName": "fruitBirthName",
                "responseVal": "fruitBirthName",
                "responseName": "Birth name",
                "responseType": "input"
            },
            {
                "fieldName": "fruitIncomeQuintals",
                "responseVal": "fruitIncomeQuintals",
                "responseName": "Income (in quintals)",
                "responseType": "number"
            },
            {
                "fieldName": "fruitPriceLakhs",
                "responseVal": "fruitPriceLakhs",
                "responseName": "Price (in lakhs)",
                "responseType": "number"
            },
            {
                "fieldName": "fruitAnnualAvgPriceQty",
                "responseVal": "fruitAnnualAvgPriceQty",
                "responseName": "Annual average price (Qty.)",
                "responseType": "number"
            },
            {
                "fieldName": "fruitSalesVolumeQuintals",
                "responseVal": "fruitSalesVolumeQuintals",
                "responseName": "Sales volume (in quintals)",
                "responseType": "number"
            },
            {
                "fieldName": "fruitSellingPriceLakhs",
                "responseVal": "fruitSellingPriceLakhs",
                "responseName": "Selling price (in lakhs)",
                "responseType": "number"
            }
        ]
    }
];

export const MISformP9 = [

    {
        "fieldNo": "01.",
        "fieldVal": "Financial Year",
        "response": [
            {
                "fieldName": "financialYear",
                "responseVal": "financialYear",
                "responseName": "Financial Year ",
                "responseType": "select",
                "options": getYearOptions(5)
            }
        ]
    },

    {
        "fieldNo": "02.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "marketCommitteeName",
                "responseVal": "marketCommitteeName",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },

    {
        "fieldNo": "03.",
        "fieldVal": "Birth name",
        "response": [
            {
                "fieldName": "birthName",
                "responseVal": "birthName",
                "responseName": "Birth name",
                "responseType": "input"
            }
        ]
    },

    {
        "fieldNo": "04.",
        "fieldVal": "Monthly price list of controlled commodities (20 kg)",
        "response": [
            {
                "fieldName": "apr",
                "responseVal": "apr",
                "responseName": "Apr",
                "responseType": "number"
            },
            {
                "fieldName": "may",
                "responseVal": "may",
                "responseName": "May",
                "responseType": "number"
            },
            {
                "fieldName": "jun",
                "responseVal": "jun",
                "responseName": "Jun",
                "responseType": "number"
            },
            {
                "fieldName": "jul",
                "responseVal": "jul",
                "responseName": "Jul",
                "responseType": "number"
            },
            {
                "fieldName": "aug",
                "responseVal": "aug",
                "responseName": "Aug",
                "responseType": "number"
            },
            {
                "fieldName": "sep",
                "responseVal": "sep",
                "responseName": "Sep",
                "responseType": "number"
            },
            {
                "fieldName": "oct",
                "responseVal": "oct",
                "responseName": "Oct",
                "responseType": "number"
            },
            {
                "fieldName": "nov",
                "responseVal": "nov",
                "responseName": "Nov",
                "responseType": "number"
            },
            {
                "fieldName": "dec",
                "responseVal": "dec",
                "responseName": "Dec",
                "responseType": "number"
            },
            {
                "fieldName": "jan",
                "responseVal": "jan",
                "responseName": "Jan",
                "responseType": "number"
            },
            {
                "fieldName": "feb",
                "responseVal": "feb",
                "responseName": "Feb",
                "responseType": "number"
            },
            {
                "fieldName": "mar",
                "responseVal": "mar",
                "responseName": "Mar",
                "responseType": "number"
            }
        ]
    },

    {
        "fieldNo": "05.",
        "fieldVal": "Annual average price",
        "response": [
            {
                "fieldName": "annualAveragePrice",
                "responseVal": "annualAveragePrice",
                "responseName": "Annual average price",
                "responseType": "number"
            }
        ]
    }
];


export const MISformP10 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Details of development work done",
        "response": [
            {
                "fieldName": "developmentWorkDetails",
                "responseVal": "developmentWorkDetails",
                "responseName": "Details of development work done",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "The purpose behind doing development work",
        "response": [
            {
                "fieldName": "purposeOfDevelopmentWork",
                "responseVal": "purposeOfDevelopmentWork",
                "responseName": "Purpose behind development work",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Total expenditure incurred on development work (in lakhs)",
        "response": [
            {
                "fieldName": "expenditureOnDevelopment",
                "responseVal": "expenditureOnDevelopment",
                "responseName": "Total expenditure on development work (in lakhs)",
                "responseType": "number"
            }
        ]
    }
];

export const MISformP11 = [
    
    {
        "fieldNo": "1",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "marketCommitteeName",
                "responseVal": "marketCommitteeName",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "2",
        "fieldVal": "Basic facilities established",
        "response": [
            {
                "fieldName": "basicFacilitiesEstablished",
                "responseVal": "basicFacilitiesEstablished",
                "responseName": "Basic facilities established",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "3",
        "fieldVal": "Facilities built during the current year",
        "response": [
            {
                "fieldName": "facilitiesBuiltCurrentYear",
                "responseVal": "facilitiesBuiltCurrentYear",
                "responseName": "Facilities built during the current year",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "4",
        "fieldVal": "Expenditure incurred on facilities constructed during the current year (in lakhs)",
        "response": [
            {
                "fieldName": "expenditureCurrentYear",
                "responseVal": "expenditureCurrentYear",
                "responseName": "Expenditure incurred during current year (lakhs)",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "5",
        "fieldVal": "Location of facility constructed during the current year",
        "response": [
            {
                "fieldName": "facilityLocationCurrentYear",
                "responseVal": "facilityLocationCurrentYear",
                "responseName": "Location of facility constructed during current year",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "6",
        "fieldVal": "Remarks",
        "response": [
            {
                "fieldName": "remarks",
                "responseVal": "remarks",
                "responseName": "Remarks",
                "responseType": "textarea"
            }
        ]
    }
];

export const MISformP12 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "permission for study tour",
        "response": [
            {
                "fieldName": "permissionForStudyTour",
                "responseVal": "permissionForStudyTour",
                "responseName": "Permission obtained",
                "responseType": "select",
                "options":["Yes","No"]

            },
            {
                "fieldName": "permissionDate",
                "responseVal": "permissionDate",
                "responseName": "Permission date",
                "responseType": "date"
            },
            {
                "fieldName": "orderNumber",
                "responseVal": "orderNumber",
                "responseName": "Order number",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Travel details, institution-wise visit details",
        "response": [
            {
                "fieldName": "travelDetails",
                "responseVal": "travelDetails",
                "responseName": "Travel details",
                "responseType": "textarea"
            },
            {
                "fieldName": "institutionWiseDetails",
                "responseVal": "institutionWiseDetails",
                "responseName": "Institution-wise visit details",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Observations and suggestions by the market committee",
        "response": [
            {
                "fieldName": "observationsFromVisit",
                "responseVal": "observationsFromVisit",
                "responseName": "Observations from the visit",
                "responseType": "textarea"
            },
            {
                "fieldName": "suggestionsForAdoption",
                "responseVal": "suggestionsForAdoption",
                "responseName": "Suggestions for adoption",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Action taken to implement as per observations and recommendations made after the visit",
        "response": [
            {
                "fieldName": "actionTaken",
                "responseVal": "actionTaken",
                "responseName": "Action taken",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Remarks",
        "response": [
            {
                "fieldName": "remarks",
                "responseVal": "remarks",
                "responseName": "Remarks",
                "responseType": "textarea"
            }
        ]
    }
];

export const MISformP13 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Brief details about the donation, including the name of the organization",
        "response": [
            {
                "fieldName": "donationDetails",
                "responseVal": "donationDetails",
                "responseName": "Donation details",
                "responseType": "textarea"
            },
            {
                "fieldName": "organizationName",
                "responseVal": "organizationName",
                "responseName": "Name of the organization",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Donation amount",
        "response": [
            {
                "fieldName": "donationAmount",
                "responseVal": "donationAmount",
                "responseName": "Donation amount",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Brief details of the benefits received",
        "response": [
            {
                "fieldName": "benefitsReceived",
                "responseVal": "benefitsReceived",
                "responseName": "Details of benefits received",
                "responseType": "textarea"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "Remarks",
        "response": [
            {
                "fieldName": "remarks",
                "responseVal": "remarks",
                "responseName": "Remarks",
                "responseType": "textarea"
            }
        ]
    }
];
export const MISformP14 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Name of the market committee",
        "response": [
            {
                "fieldName": "nameOfMarketCommittee",
                "responseVal": "nameOfMarketCommittee",
                "responseName": "Name of the market committee",
                "responseType": "input"
            }
        ]
    },
    {
        "fieldNo": "02.",
        "fieldVal": "Complaints filed during the year",
        "response": [
            {
                "fieldName": "complaintsFiledDuringYear",
                "responseVal": "complaintsFiledDuringYear",
                "responseName": "Number of complaints filed during the year",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "03.",
        "fieldVal": "Last year's ongoing complaint",
        "response": [
            {
                "fieldName": "lastYearsOngoingComplaint",
                "responseVal": "lastYearsOngoingComplaint",
                "responseName": "Last year's ongoing complaint",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "04.",
        "fieldVal": "Complaints cancelled during the year",
        "response": [
            {
                "fieldName": "complaintsCancelled",
                "responseVal": "complaintsCancelled",
                "responseName": "Complaints cancelled during the year",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "05.",
        "fieldVal": "How many were punished or fined?",
        "response": [
            {
                "fieldName": "punishedOrFined",
                "responseVal": "punishedOrFined",
                "responseName": "Number punished or fined",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "06.",
        "fieldVal": "Ongoing complaint at year end",
        "response": [
            {
                "fieldName": "ongoingComplaintAtYearEnd",
                "responseVal": "ongoingComplaintAtYearEnd",
                "responseName": "Ongoing complaint at year end",
                "responseType": "number"
            }
        ]
    },
    {
        "fieldNo": "07.",
        "fieldVal": "Special note",
        "response": [
            {
                "fieldName": "specialNote",
                "responseVal": "specialNote",
                "responseName": "Special note",
                "responseType": "textarea"
            }
        ]
    }
];

export const MISformP15 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Name of the market committee",
    "response": [
      {
        "fieldName": "marketCommitteeName",
        "responseVal": "marketCommitteeName",
        "responseName": "Name of the market committee",
        "responseType": "input"
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Name of the secretary, is he/she a full-time secretary or not?",
    "response": [
      {
        "fieldName": "secretaryName",
        "responseVal": "secretaryName",
        "responseName": "secretaryName",
        "responseType": "input",
      },
      {
        "fieldName": "secretaryFullTimeStatus",
        "responseVal": "secretaryFullTimeStatus",
        "responseName": "secretaryFullTimeStatus",
        "responseType": "select",
        "options": ["Full-time", "Part-time", "Contractual", "Vacant"]
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "Number of Market Committee Establishments at the end of the year",
    "response": [
      {
        "fieldName": "establishmentsAtYearEnd",
        "responseVal": "establishmentsAtYearEnd",
        "responseName": "Establishments at year end",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Full names of all employees in the institution",
    "response": [
      {
        "fieldName": "employeesFullNames",
        "responseVal": "employeesFullNames",
        "responseName": "Employee full names",
        "responseType": "textarea"
      }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldVal": "Number of new employees hired during the current year",
    "response": [
      {
        "fieldName": "newEmployeesHired",
        "responseVal": "newEmployeesHired",
        "responseName": "New employees hired",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "06.",
    "fieldVal": "Number of employees approved as per staff schedule",
    "response": [
      {
        "fieldName": "approvedEmployees",
        "responseVal": "approvedEmployees",
        "responseName": "Approved employees",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "07.",
    "fieldVal": "Approval of the newly appointed employees ",
    "response": [
      {
        "fieldName": "newAppointmentApproval",
        "responseVal": "newAppointmentApproval",
        "responseName": "Approval status",
        "responseType": "select",
        "options": ["Yes", "No", "Pending"]
      },
      {
        "fieldName": "newAppointmentApprovalDate",
        "responseVal": "newAppointmentApprovalDate",
        "responseName": "Approval Date / Number",
        "responseType": "date"
      }
    ]
  },
  {
    "fieldNo": "08.",
    "fieldVal": "Remarks",
    "response": [
      {
        "fieldName": "remarks",
        "responseVal": "remarks",
        "responseName": "Remarks",
        "responseType": "textarea"
      }
    ]
  }
];

export const MISformP16 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Name of the market committee",
    "response": [
      {
        "fieldName": "marketCommitteeName",
        "responseVal": "marketCommitteeName",
        "responseName": "Name of the market committee",
        "responseType": "input"
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Does the market committee hold regular yard sales?",
    "response": [
      {
        "fieldName": "regularYardSales",
        "responseVal": "regularYardSales",
        "responseName": "Regular yard sales",
        "responseType": "select",
        "options": ["Yes", "No", "Sometimes"]
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "If the yard sale is not happening, detailed reasons and your opinion on this",
    "response": [
      {
        "fieldName": "yardSaleNotHappeningReason",
        "responseVal": "yardSaleNotHappeningReason",
        "responseName": "Reason / Opinion",
        "responseType": "textarea"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Names of suspended market committees and reasons for suspension",
    "response": [
      {
        "fieldName": "suspendedMarketCommittees",
        "responseVal": "suspendedMarketCommittees",
        "responseName": "Suspended committees and reasons",
        "responseType": "textarea"
      }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldVal": "Opinions on what steps you would suggest to implement the Market Committee",
    "response": [
      {
        "fieldName": "suggestedSteps",
        "responseVal": "suggestedSteps",
        "responseName": "Suggested steps",
        "responseType": "textarea"
      }
    ]
  }
];

export const MISformP17 = [

  {
    "fieldNo": "01.",
    "fieldVal": "District",
    "response": [
      {
        "fieldName": "district",
        "responseVal": "district",
        "responseName": "District",
        "responseType": "input"
      }
    ]
  },

  {
    "fieldNo": "02.",
    "fieldVal": "Name of the market committee",
    "response": [
      {
        "fieldName": "marketCommitteeName",
        "responseVal": "marketCommitteeName",
        "responseName": "Market Committee Name",
        "responseType": "input"
      }
    ]
  },

  {
    "fieldNo": "03.",
    "fieldVal": "Notification details regarding formation of Market Committee",
    "response": [
      {
        "fieldName": "marketCommitteeNotificationNo",
        "responseVal": "marketCommitteeNotificationNo",
        "responseName": "Notification Number",
        "responseType": "input"
      },
      {
        "fieldName": "marketCommitteeNotificationDate",
        "responseVal": "marketCommitteeNotificationDate",
        "responseName": "Notification Date",
        "responseType": "date"
      }
    ]
  },

  {
    "fieldNo": "04.",
    "fieldVal": "Name of the main yard",
    "response": [
      {
        "fieldName": "mainYardName",
        "responseVal": "mainYardName",
        "responseName": "Main Yard Name",
        "responseType": "input"
      }
    ]
  },

  {
    "fieldNo": "05.",
    "fieldVal": "Main yard announcement notification details",
    "response": [
      {
        "fieldName": "mainYardNotificationNo",
        "responseVal": "mainYardNotificationNo",
        "responseName": "Main Yard Notification Number",
        "responseType": "input"
      },
      {
        "fieldName": "mainYardNotificationDate",
        "responseVal": "mainYardNotificationDate",
        "responseName": "Main Yard Notification Date",
        "responseType": "date"
      }
    ]
  },

  {
    "fieldNo": "06.",
    "fieldVal": "Main yard land details including village name/survey number",
    "response": [
      {
        "fieldName": "mainYardLandDetails",
        "responseVal": "mainYardLandDetails",
        "responseName": "Main Yard Land Details",
        "responseType": "textarea"
      }
    ]
  },

  {
    "fieldNo": "07.",
    "fieldVal": "Was it purchased or given by the government?(Main Yard)",
    "response": [
      {
        "fieldName": "mainYardAcquiredType",
        "responseVal": "mainYardAcquiredType",
        "responseName": "Acquired Type",
        "responseType": "select",
        "options": ["Purchased", "Given by Government"]
      }
    ]
  },

  {
    "fieldNo": "08.",
    "fieldVal": "Subyard name",
    "response": [
      {
        "fieldName": "subyardName",
        "responseVal": "subyardName",
        "responseName": "Subyard Name",
        "responseType": "input"
      }
    ]
  },

  {
    "fieldNo": "09.",
    "fieldVal": "Subyard announcement notification details",
    "response": [
      {
        "fieldName": "subyardNotificationNo",
        "responseVal": "subyardNotificationNo",
        "responseName": "Subyard Notification Number",
        "responseType": "input"
      },
      {
        "fieldName": "subyardNotificationDate",
        "responseVal": "subyardNotificationDate",
        "responseName": "Subyard Notification Date",
        "responseType": "date"
      }
    ]
  },

  {
    "fieldNo": "10.",
    "fieldVal": "Subyard land details including village name/survey number",
    "response": [
      {
        "fieldName": "subyardLandDetails",
        "responseVal": "subyardLandDetails",
        "responseName": "Subyard Land Details",
        "responseType": "textarea"
      }
    ]
  },

  {
    "fieldNo": "11.",
    "fieldVal": "Was it purchased or given by the government? (Subyard)",
    "response": [
      {
        "fieldName": "subyardAcquiredType",
        "responseVal": "subyardAcquiredType",
        "responseName": "Acquired Type",
        "responseType": "select",
        "options": ["Purchased", "Given by Government"]
      }
    ]
  }
];

export const MISformP18 = [

  {
    "fieldNo": "01.",
    "fieldVal": "Name of the market committee",
    "response": [
      {
        "fieldName": "marketCommitteeName",
        "responseVal": "marketCommitteeName",
        "responseName": "Market Committee Name",
        "responseType": "input"
      }
    ]
  },

  {
    "fieldNo": "02.",
    "fieldVal": "Notification details of goods taken under control",
    "response": [
      {
        "fieldName": "goodsNotificationNo",
        "responseVal": "goodsNotificationNo",
        "responseName": "Notification Number",
        "responseType": "input"
      },
      {
        "fieldName": "goodsNotificationDate",
        "responseVal": "goodsNotificationDate",
        "responseName": "Notification Date",
        "responseType": "date"
      }
    ]
  },

  {
    "fieldNo": "03.",
    "fieldVal": "Name of the subjects taken under control",
    "response": [
      {
        "fieldName": "subjectsTakenUnderControl",
        "responseVal": "subjectsTakenUnderControl",
        "responseName": "Subjects Taken Under Control",
        "responseType": "input"
      }
    ]
  },

  {
    "fieldNo": "04.",
    "fieldVal": "Remarks",
    "response": [
      {
        "fieldName": "remarks",
        "responseVal": "remarks",
        "responseName": "Remarks",
        "responseType": "input"
      }
    ]
  }
];

export const MISformP19 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Select Year",
    "response": [
      {
        "fieldName": "incomeYear",
        "responseVal": "incomeYear",
        "responseName": "Year",
        "responseType": "select",
        "options": getYearOptions(3)
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Market Fee (in Rs. lakhs)",
    "response": [
      {
        "fieldName": "marketFee",
        "responseVal": "marketFee",
        "responseName": "Market Fee",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "License Fee (in Rs. lakhs)",
    "response": [
      {
        "fieldName": "licenseFee",
        "responseVal": "licenseFee",
        "responseName": "License Fee",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Others (in Rs. lakhs)",
    "response": [
      {
        "fieldName": "others",
        "responseVal": "others",
        "responseName": "Others",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldVal": "Total (in Rs. lakhs)",
    "response": [
      {
        "fieldName": "totalIncome",
        "responseVal": "totalIncome",
        "responseName": "Total Income",
        "responseType": "number"
      }
    ]
  }
];

export const MISformP20 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Select Year",
    "response": [
      {
        "fieldName": "licenseYear",
        "responseVal": "licenseYear",
        "responseName": "Year",
        "responseType": "select",
        "options": getYearOptions(4)
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Number of licensed traders",
    "response": [
      {
        "fieldName": "numberOfLicensedTraders",
        "responseVal": "numberOfLicensedTraders",
        "responseName": "Number of licensed traders",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "Number of licensed cooperative societies",
    "response": [
      {
        "fieldName": "numberOfLicensedCooperativeSocieties",
        "responseVal": "numberOfLicensedCooperativeSocieties",
        "responseName": "Number of licensed cooperative societies",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Total overall number of licensees",
    "response": [
      {
        "fieldName": "totalLicensees",
        "responseVal": "totalLicensees",
        "responseName": "Total overall number of licensees",
        "responseType": "number"
      }
    ]
  }
];
export const MISformP21 = [
    {
        "fieldNo": "01.",
        "fieldVal": "Buying and selling of commodities in the market square (Q1)",
        "response": [
            {
                "fieldName": "typeOfBirth",
                "responseVal": "typeOfBirth",
                "responseName": "Type of birth",
                "responseType": "select",
                "options": [
                    "Fiber",
                    "Grain",
                    "Beans",
                    "Oilseeds",
                    "Spices, seasonings and other products",
                    "Fruit",
                    "Vegetables",
                    "Other"
                ]
            },
            {
                "fieldName": "birthName",
                "responseVal": "birthName",
                "responseName": "Birth name",
                "responseType": "select",
                "options": [
                    "Cotton",
                    "Wheat",
                    "Rice",
                    "Maize",
                    "Gram",
                    "Tur",
                    "Urad",
                    "Groundnut",
                    "Mustard",
                    "Soybean",
                    "Chilli",
                    "Coriander",
                    "Cumin",
                    "Onion",
                    "Potato",
                    "Tomato",
                    "Banana",
                    "Mango",
                    "Apple",
                    "Other"
                ]
            },
            {
                "fieldName": "year1",
                "responseVal": "year2022_23",
                "responseName": "2022-23 (in Q1 lakhs)",
                "responseType": "number"
            },
            {
                "fieldName": "year2",
                "responseVal": "year2023_24",
                "responseName": "2023-24 (in Q1 lakhs)",
                "responseType": "number"
            },
            {
                "fieldName": "year3",
                "responseVal": "year2024_25",
                "responseName": "2024-25 (in Q1 lakhs)",
                "responseType": "number"
            }
        ]
    }
];
 
export const MISformP22 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Select Year",
    "response": [
      {
        "fieldName": "year",
        "responseVal": "year",
        "responseName": "Year",
        "responseType": "select",
        "options": getYearOptions(4)
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Income (Rs. lakhs)",
    "response": [
      {
        "fieldName": "incomeLakhs",
        "responseVal": "incomeLakhs",
        "responseName": "Income (Rs. lakhs)",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "Price (in Rs. crore)",
    "response": [
      {
        "fieldName": "priceCrore",
        "responseVal": "priceCrore",
        "responseName": "Price (Rs. crore)",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Remarks",
    "response": [
      {
        "fieldName": "remarks",
        "responseVal": "remarks",
        "responseName": "Remarks",
        "responseType": "input"
      }
    ]
  }
];

export const MISformP23 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Committee name",
    "response": [
      {
        "fieldName": "committeeName",
        "responseVal": "committeeName",
        "responseName": "Committee name",
        "responseType": "input"
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Auction Shed",
    "response": [
      {
        "fieldName": "auctionShed",
        "responseVal": "auctionShed",
        "responseName": "Auction Shed",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "Office building",
    "response": [
      {
        "fieldName": "officeBuilding",
        "responseVal": "officeBuilding",
        "responseName": "Office building",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Shopcom Godown",
    "response": [
      {
        "fieldName": "shopcomGodown",
        "responseVal": "shopcomGodown",
        "responseName": "Shopcom Godown",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldVal": "Elevation Bridges",
    "response": [
      {
        "fieldName": "elevationBridges",
        "responseVal": "elevationBridges",
        "responseName": "Elevation Bridges",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "06.",
    "fieldVal": "Farmers’ Rest House",
    "response": [
      {
        "fieldName": "farmersRestHouse",
        "responseVal": "farmersRestHouse",
        "responseName": "Farmers’ Rest House",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "07.",
    "fieldVal": "Canteen",
    "response": [
      {
        "fieldName": "canteen",
        "responseVal": "canteen",
        "responseName": "Canteen",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "08.",
    "fieldVal": "Soil Testing Lab",
    "response": [
      {
        "fieldName": "soilTestingLab",
        "responseVal": "soilTestingLab",
        "responseName": "Soil Testing Lab",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "09.",
    "fieldVal": "Grading Cleaning Facilities",
    "response": [
      {
        "fieldName": "gradingCleaningFacilities",
        "responseVal": "gradingCleaningFacilities",
        "responseName": "Grading Cleaning Facilities",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldVal": "Sales and Exhibition Center",
    "response": [
      {
        "fieldName": "salesExhibitionCenter",
        "responseVal": "salesExhibitionCenter",
        "responseName": "Sales and Exhibition Center",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldVal": "Cold storage",
    "response": [
      {
        "fieldName": "coldStorage",
        "responseVal": "coldStorage",
        "responseName": "Cold storage",
        "responseType": "select",
        "options": ["Yes", "No"]
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldVal": "Other",
    "response": [
      {
        "fieldName": "otherFacilitys",
        "responseVal": "otherFacilitys",
        "responseName": "Other",
        "responseType": "input"
      }
    ]
  }
];

export const MISformP24 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Available Name of facilities",
    "response": [
      {
        "fieldName": "facilityAvailability",
        "responseVal": "facilityAvailability",
        "responseName": "Available Name of facilities",
        "responseType": "select",
        "options": [
          "Oxon Shade",
          "Office Building",
          "Shopkam Godown",
          "Electronic Way-bridge",
          "Farmer Restroom",
          "Canteen",
          "Soil Testing Laboratory",
          "Grading Cleaning Facility",
          "Sales are down / Exhibition cell",
          "Cold Storage",
          "Farmer Information Center",
          "Solid Waste Management",
          "Fire Fighter (Bamboo)",
          "Rs. Testing Laboratory",
          "If other, please specify"
        ]
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Available information (Market Committee Wise)",
    "response": [
      {
        "fieldName": "marketCommitteeColumn1",
        "responseVal": "marketCommitteeColumn1",
        "responseName": "Market Committee – Column 1",
        "responseType": "number"
      },
      {
        "fieldName": "marketCommitteeColumn2",
        "responseVal": "marketCommitteeColumn2",
        "responseName": "Market Committee – Column 2",
        "responseType": "number"
      },
      {
        "fieldName": "marketCommitteeColumn3",
        "responseVal": "marketCommitteeColumn3",
        "responseName": "Market Committee – Column 3",
        "responseType": "number"
      },
      {
        "fieldName": "marketCommitteeColumn4",
        "responseVal": "marketCommitteeColumn4",
        "responseName": "Market Committee – Column 4",
        "responseType": "number"
      }
    ]
  }
];   

export const MISformP25 = [
  {
    "fieldNo": "01.",
    "fieldVal": "Select Year",
    "response": [
      {
        "fieldName": "year",
        "responseVal": "year",
        "responseName": "Year",
        "responseType": "select",
        "options": getYearOptions(4)
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Number of Authorized Dealers",
    "response": [
      {
        "fieldName": "authorizedDealers",
        "responseVal": "authorizedDealers",
        "responseName": "Number of Authorized Dealers",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "Quantity of goods classified during the year",
    "response": [
      {
        "fieldName": "quantityClassified",
        "responseVal": "quantityClassified",
        "responseName": "Quantity of goods classified during the year",
        "responseType": "number"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "Value of classified goods (in Rs. lakhs)",
    "response": [
      {
        "fieldName": "valueClassified",
        "responseVal": "valueClassified",
        "responseName": "Value of classified goods (in Rs. lakhs)",
        "responseType": "number"
      }
    ]
  }
];

export const MISformP26 = [
  
  {
    "fieldNo": "01.",
    "fieldVal": "Center name",
    "response": [
      {
        "fieldName": "centerName",
        "responseVal": "centerName",
        "responseName": "Center name",
        "responseType": "input"
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "Names of classified species",
    "response": [
      {
        "fieldName": "classifiedSpecies",
        "responseVal": "classifiedSpecies",
        "responseName": "Names of classified species",
        "responseType": "input"
      }
    ]
  }
];









 
